import { render, staticRenderFns } from "./InputImage.vue?vue&type=template&id=5857ed7b&scoped=true&"
import script from "./InputImage.vue?vue&type=script&lang=js&"
export * from "./InputImage.vue?vue&type=script&lang=js&"
import style0 from "./InputImage.vue?vue&type=style&index=0&id=5857ed7b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5857ed7b",
  null
  
)

export default component.exports